import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { BackgroundTaskProvider } from './contexts/BackgroundTaskContext'
import { CategoryProvider } from './contexts/CategoryContext'
import Layout from './components/Layout'
import { BackgroundTaskNotification } from './components/BackgroundTaskNotification'
import ProtectedRoute from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import SessionsPage from './pages/SessionsPage'
import SessionDetailsPage from './pages/SessionDetailsPage'
import GuidelinesPage from './pages/GuidelinesPage'
import ManualPage from './pages/ManualPage'
import ReportsPage from './pages/ReportsPage'
import AdminPage from './pages/AdminPage'
import CatalogPage from './pages/CatalogPage'
import UserProfilePage from './pages/UserProfilePage'
import TestingSessionsPage from './pages/TestingSessionsPage'
import TestingSessionDetailsPage from './pages/TestingSessionDetailsPage'

function App() {
  return (
    <Router>
      <AuthProvider>
        <BackgroundTaskProvider>
          <CategoryProvider>
            <BackgroundTaskNotification />
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/sessions" element={<SessionsPage />} />
                      <Route path="/sessions/:sessionId" element={<SessionDetailsPage />} />
                      <Route path="/guidelines" element={<GuidelinesPage />} />
                      <Route path="/manual" element={<ManualPage />} />
                      <Route path="/reports" element={<ReportsPage />} />
                      <Route path="/profile" element={<UserProfilePage />} />
                      <Route
                        path="/catalog"
                        element={
                          <ProtectedRoute requireAdmin>
                            <CatalogPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/testing"
                        element={
                          <ProtectedRoute requireAdmin>
                            <TestingSessionsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/testing/:sessionId"
                        element={
                          <ProtectedRoute requireAdmin>
                            <TestingSessionDetailsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin"
                        element={
                          <ProtectedRoute requireAdmin>
                            <AdminPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/users"
                        element={
                          <ProtectedRoute requireAdmin>
                            <AdminPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/rooms"
                        element={
                          <ProtectedRoute requireAdmin>
                            <AdminPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/settings"
                        element={
                          <ProtectedRoute requireAdmin>
                            <AdminPage />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          </CategoryProvider>
        </BackgroundTaskProvider>
      </AuthProvider>
    </Router>
  )
}

export default App